import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_DELIVERY_NOTE_ROSTER_EXPORT,
  SOFTLINE_API_DELIVERY_NOTE_ROSTER_IMPORT,
  SOFTLINE_API_DELIVERY_NOTE_ROSTER_MAIL,
} from '../delivery-note-roster.api';

@Injectable()
export class DeliveryNoteRosterMenuBarActionsRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  async import(): Promise<void> {
    await this.dataAccess.create({ path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_IMPORT }, {});
  }

  async export(beginDate: string, endDate: string): Promise<void> {
    await this.dataAccess.create(
      {
        path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_EXPORT,
        queryParams: { beginDate, endDate },
      },
      {}
    );
  }

  async sendMail(id: number): Promise<void> {
    await this.dataAccess.create(
      { path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_MAIL, pathParams: { id } },
      {}
    );
  }
}
